export const lyric03 = `Oh damn, oh damn, oh damn
I'm so perplexed
With just one breath, I'm locked in
Oh damn, oh damn, oh damn
I'm so perplexed
On that, it's almost shocking
I know, I know you know you're scared
Your heart, your mind, your soul, your body
They won't, they won't, they won't be careful
But I guess that you don't know me
Cause if I want you, and I want you, babe
Ain't going backwards, won't ask for space
Cause space is just a word made up by someone who's afraid to get too...
Close, ooh
Oh, so close, ooh
I want you close, ooh
Cause space is just a word made up by someone who's afraid to get close, ooh
Oh, so close, ooh
I want you close, ooh
Oh, I want you close, and close ain't close enough, no
Oh man, oh man
I am not really known for ever being speechless
But now, but now somehow
My words roll off my tongue right onto your lips, oh
I'm keeping cool while you keep smiling
Saying all the things I'm thinking
Oh man, oh man
I am like you so I want proof of what you're feeling
Cause if I want you, and I want you, babe
Ain't going backwards, won't ask for space
Cause space is just a word made up by someone who's afraid to get too...
Close, ooh
Oh, so close, ooh
I want you close, ooh
Cause space was just a word made up by someone who's afraid to get close, ooh
Oh, so close, ooh
I want you close, ooh
Oh, I want you close, and close ain't close enough, no
Cause if I want you, and I want you, babe
Ain't going backwards, won't ask for space
Cause space was just a word made up by someone who's afraid to get too... close
Close, ooh
Oh, so close, ooh
I want you close, ooh
Cause space was just a word made up by someone who's afraid to get close, ooh
Oh, so close, ooh
I want you close, ooh
Oh, I want you close, and close ain't close enough, no
Oh, I want you close, and close ain't close enough, no`